import React, { Component } from 'react';
import { Form, Modal, message, Input, Button as AntButton, Button } from 'antd';
import { services } from '@comall-backend-builder/core';
import { navigation } from '@comall-backend-builder/core/lib/services';
import { errorHandle } from '../../services';
const api = services.api;
/**
 * 置换skn
 */
class Displaceskn extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            // iscommerce: false, // 是否申商合
            // islock: false, // 是否锁定
            // isstock: false, //有无库存
        };
    }

    showModal = () => {
        this.setState({
            visible: true,
        });
        this.props.form.setFields({
            saleNumStatus: {
                value: this.props.rows.saleNumStatus,
            },
            maxSaleNum: {
                value: this.props.rows.maxSaleNum,
            },
        });
    };

    handleOk = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            // console.log()
            if (!err) {
                api.put(
                    {},
                    {
                        apiPath: `/shippingOrderNew/update_skn/${this.props.rows.orderItemId}?skn_code=${values.expressNumber}`,
                    }
                )
                    .then((res) => {
                        if (res.data.result) {
                            this.setState({
                                visible: false,
                            });
                            let params = {
                                type: 'FK_POINTS',
                            };
                            // 列表数据刷新
                            this.props.entity.search({
                                ...params,
                                ...this.props.entity.filters,
                            });
                            this.props.form.resetFields();
                            message.success('修改成功');
                        }

                        if (!res.data.result) message.error(`${res?.data?.tips}`);
                    })
                    .catch(errorHandle);
            } else {
                message.error('请填写完整表单再提交');
            }
        });
    };

    handleCancel = (e) => {
        this.props.form.resetFields();
        this.setState({
            visible: false,
        });
    };

    render() {
        const {
            rows: { deliveryStatus, orderNo, shopName },
        } = this.props;
        const { visible } = this.state;
        return (
            <div>
                {deliveryStatus == 1 && (
                    <Button
                        type="link"
                        target="_blank"
                        onClick={() => {
                            if (shopName !== '品真阁线上') {
                                message.warning('该订单非本系统发起，请返回原销售渠道操作！');
                                return;
                            }
                            let path = `/trade/changeSKu/add/${orderNo}`;
                            navigation.goto(path);
                        }}
                    >
                        置换skn
                    </Button>
                )}

                <Modal
                    visible={visible}
                    title="置换skn"
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                >
                    <Form labelCol={{ span: 5 }} wrapperCol={{ span: 14 }} layout="horizontal">
                        <Form.Item label="原SKN:">{this.props?.rows?.sknCode}</Form.Item>
                    </Form>
                    <Form
                        style={{ marginTop: '-20px' }}
                        labelCol={{ span: 5 }}
                        wrapperCol={{ span: 14 }}
                        layout="horizontal"
                    >
                        <Form.Item label="修改SKN为:">
                            {this.props.form.getFieldDecorator('expressNumber', {
                                rules: [
                                    { required: true, message: '修改后的SKN不能为空' },
                                    {
                                        pattern: /^[A-Za-z0-9]+$/,
                                        message: '名称仅支持数字、字母输入',
                                    },
                                ],
                            })(<Input name="expressNumber" placeholder="请输入要修改的SKN" />)}
                        </Form.Item>
                    </Form>
                </Modal>
            </div>
        );
    }
}

export default Form.create()(Displaceskn);
